/**
 * The rules a climb can carry on top of its holds — no crimping, no matching,
 * feet anywhere, no feet, no volumes. Kept in step with `Climb#climb_exceptions`
 * on the server, whose flag column stores exactly these names.
 *
 * Labels live in i18n under `climbExceptions.*`, so a list of chips is this
 * array mapped through `t`.
 */
export const CLIMB_EXCEPTIONS = [
  'no_crimp',
  'no_matching',
  'free_feet',
  'no_feet',
  'no_volumes',
] as const;

export type ClimbException = (typeof CLIMB_EXCEPTIONS)[number];
